import { render, staticRenderFns } from "./resumen-barra.vue?vue&type=template&id=d1191506&scoped=true&"
import script from "./resumen-barra.vue?vue&type=script&lang=ts&"
export * from "./resumen-barra.vue?vue&type=script&lang=ts&"
import style0 from "./resumen-barra.vue?vue&type=style&index=0&id=d1191506&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1191506",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VImg,VRow,VSpacer})
